export const messages = {
  title: '身体数据',
  weight: '体重',
  bodyFat: '体脂',
  add: '记录',
  sync: '同步',
  empty: '暂无数据',
  kg: 'kg',
  percent: '%',
  date: '日期'
} as const
